import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-toastify/dist/ReactToastify.css';
import { MasterLayout } from 'routes/routes';
import { ScrollToTop, AnimatedRoutes } from 'components/core';
import { AuthProvider } from 'context/AuthContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ScrollToTop>
        <HelmetProvider>
          <MasterLayout>
            <AnimatedRoutes />
          </MasterLayout>
          <ToastContainer
            position="bottom-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            limit={3}
          />
        </HelmetProvider>
      </ScrollToTop>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
